import { integration } from 'errorTracker';

export default {
  install(Vue) {
    // propsバリデーションなどで発生するwarnを報告
    Vue.config.warnHandler = (msg, vm, trace) => {
      integration.report(msg, vm, 'warning', trace);
    };
  },
};
